import React from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
// import {
//   createDepartment,
//   clearDepartmentStatus,
// } from "../../../../../redux/customer/customerSlice";
import { createDepartment, clearDepartmentStatus } from "../../../../../redux/customer/customerSlice";
import { useEffect, useState } from "react";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";
import { useSelector, useDispatch } from "react-redux";
import { createPortal } from "react-dom";
import { useParams } from "react-router-dom";
const AddDepartment = ({ onOpen, onClose }) => {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const {
    loading,
    error,
    departmentSuccess: success,
  } = useSelector((state) => state.customer);
  const [formData, setFormData] = useState({
    name: "",
    department_type: "",
    other_type: "",
    isActive: "true",
  });

  // Handle successful creation
  const handleSuccessCleanup = () => {
    setFormData({
      name: "",
      department_type: "",
      other_type: "",
      isActive: "true",
    });
    dispatch(clearDepartmentStatus());
    onClose();
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        handleSuccessCleanup();
      }, 2000); // 2 seconds delay
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    const typeToSave =
      formData.department_type === "Other"
        ? formData.other_type
        : formData.department_type;
    if (!formData.name || !typeToSave) {
      // Basic validation
      return;
    }
    dispatch(
      createDepartment({
        userId,
        data: {
          name: formData.name,
          department_type: typeToSave,
          isActive: formData.isActive,
        },
      }),
    );
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      department_type: "",
      other_type: "",
      isActive: "true",
    });
    dispatch(clearDepartmentStatus());
    onClose();
  };

  return (
    <div>
      <DailogBox
        open={onOpen}
        onCancel={handleCancel}
        width="90%"
        maxWidth="700px"
      >
        <div className="p-6">
          {/* Form Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Department Name */}
            <div>
              <label className="text-sm text-[#06513D]">Department Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter department name"
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
            </div>

            {/* Department Type */}
            <div>
              <label className="text-sm text-[#06513D]">Department Type</label>
              <select
                name="department_type"
                value={formData.department_type}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select Type</option>
                <option value="Technical">Technical</option>
                <option value="Operations">Operations</option>
                <option value="Administrative">Administrative</option>
                <option value="Sales">Sales</option>
                <option value="Marketing">Marketing</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Custom Type (Parallel to Status if visible) */}

            {/* Status */}
            <div>
              <label className="text-sm text-[#06513D]">Status</label>
              <select
                name="isActive"
                value={formData.isActive}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            {formData.department_type === "Other" && (
              <div>
                <label className="text-sm text-[#06513D]">Specify Type</label>
                <input
                  type="text"
                  name="other_type"
                  value={formData.other_type}
                  onChange={handleChange}
                  placeholder="Enter department type"
                  className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none animate-fadeIn"
                />
              </div>
            )}
          </div>

          {/* Error Message handled via PopupCard */}
          {error &&
            createPortal(
              <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40 px-4">
                <PopupCard
                  type="error"
                  title="Error"
                  message={error}
                  confirmText="Close"
                  onConfirm={() => dispatch(clearDepartmentStatus())}
                />
              </div>,
              document.body,
            )}

          {/* Success Message handled via PopupCard */}
          {success &&
            createPortal(
              <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40 px-4">
                <PopupCard
                  type="success"
                  title="Success"
                  message="Department created successfully!"
                />
              </div>,
              document.body,
            )}

          {/* Buttons */}
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={handleCancel}
              className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
              disabled={loading}
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              disabled={loading || !formData.name || !formData.department_type}
              className={`px-6 py-2 bg-[#06513D] text-white rounded-md flex items-center gap-2 ${
                loading || !formData.name || !formData.department_type
                  ? "opacity-70 cursor-not-allowed"
                  : ""
              }`}
            >
              {loading ? (
                <>
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  Saving...
                </>
              ) : (
                "Add Details"
              )}
            </button>
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default AddDepartment;
